export const GET_CALENDAR_INFO = 'GET_CALENDAR_INFO';
export const GET_DASHBOARD_INFO = 'GET_DASHBOARD_INFO';
export const GET_NEWS = 'GET_NEWS';
export const GET_NEWS_DONE = 'GET_NEWS_DONE';
export const GETTING_NEWS = 'GETTING_NEWS';
